export const customerLogos = {
  en: [
    {
      icon: 'https://static.andersenlab.com/andersenlab/new-andersensite/cases/samsung/logo/samsung-gray.svg',
      alt: 'Samsung',
    },
    {
      icon: 'https://static.andersenlab.com/andersenlab/new-andersensite/customers/verivox-gmbh.svg',
      alt: 'Verivox',
    },
    {
      icon: 'https://static.andersenlab.com/andersenlab/new-andersensite/customers/tui.svg',
      alt: 'TUI',
    },
  ],
  us: [
    {
      icon: 'https://static.andersenlab.com/andersenlab/new-andersensite/cases/samsung/logo/samsung-gray.svg',
      alt: 'Samsung',
    },
    {
      icon: 'https://static.andersenlab.com/andersenlab/new-andersensite/customers/asset-book-gray.svg',
      alt: 'Asset Book',
    },
    {
      icon: 'https://static.andersenlab.com/andersenlab/new-andersensite/customers/tiger-connect-gray.svg',
      alt: 'Tiger Connect',
    },
  ],
  de: [
    {
      icon: 'https://content.andersenlab.com/common-data/grey-logo/t-systems/1753181540.svg',
      alt: 'T-Systems',
    },
    {
      icon: 'https://static.andersenlab.com/andersenlab/new-andersensite/customers/siemens-gray.svg',
      alt: 'Siemens',
    },
    {
      icon: 'https://static.andersenlab.com/andersenlab/new-andersensite/customers/verivox-gmbh.svg',
      alt: 'Verivox GmbH',
    },
  ],
};
